// Hooks
import { useState } from 'react';

// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
// import "react-phone-input-2/lib/style.css";

// Translation Library
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

// Component
import MedicalInterests from './MedicalInterests';
import HearAboutUs from './HearAboutUs';
import Events from './Events';

// Material UI Library
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Alert from '@mui/material/Alert';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import AcademicLevel from './AcademicLevel';

// import countries from 'i18n-iso-countries';
import countries from "i18n-iso-countries";
import arLocale from "i18n-iso-countries/langs/ar.json"; // lang and countries
import enLocale from "i18n-iso-countries/langs/en.json";

// Server and storage
const baseURL = process.env.REACT_APP_API_BASE_URL;
const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

// get the country
countries.registerLocale(arLocale);
countries.registerLocale(enLocale);
const allCountryCodes = countries.getAlpha2Codes(); // all country codes
const allCountries = Object.keys(allCountryCodes).map(code => ({
  code,
  name_en: countries.getName(code, "en"),
  name_ar: countries.getName(code, "ar"),
}));


const SignUp = () => {

  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    work_address: "",
    academic_level: '',
    specialization: '',
    country: "Syrian Arab Republic",
    city: "",
    landline_phone: "",
    email: "",
    phone: "",
    interests: [],
    interest_details: "",
    heard_about_us: "",
    other_heard_about_us: '',
    events: [],
  });
  const [errorsData, setErrorsdata] = useState({
    first_name: false,
    last_name:false,
    work_address: false,
    academic_level: false,
    // specialization: false,
    country: false,
    city: false,
    // landline_phone: false,
    phone: false,
    email: false,
    interests: false,
    // interest_details: false,
    heard_about_us: false,
    other_heard_about_us: false,
    events: false
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("")
  const [showimage, setshowimage]=useState(null)
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "heard_about_us") {
      setFormData(prev => ({
        ...prev,
        heard_about_us: value,
        other_heard_about_us:  ''
      }));
    }
    else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrorsdata(prev => ({ ...prev, [name]: false }));
  };
  const handleSubmit = async (e) => {
    console.log("sdflkmsdklfmsd")
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const newErrors = {
      first_name: formData.first_name.trim() === '',
      last_name: formData.last_name.trim() === '',
      work_address: formData.work_address.trim() === '',
      academic_level: formData.academic_level.trim() === '',
      // specialization: formData.specialization.trim() === '',
      country: formData.country.trim() === '',
      city: formData.city.trim() === '',
      // landline_phone: formData.landline_phone === '',
      phone: formData.phone.trim() === '',
      email: formData.email.trim() === '' || !emailRegex.test(formData.email.trim()),
      interests: formData.interests.length === 0,
      // interest_details: formData.interest_details.trim() === '',
      heard_about_us: formData.heard_about_us.trim() === '',
      other_heard_about_us: formData.heard_about_us === "other" ? formData.other_heard_about_us.trim() === '': "",
      events: formData.events.length === 0
    };
    setErrorsdata(newErrors);
    const hasErrors = Object.values(newErrors).some(val => val);
    if (hasErrors) {
      setLoading(false);
      console.log(loading)
      return;
    }
    else {
      setLoading(true);
      try {
        const res = await fetch(`${baseURL}/visitor-register`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', // sent json
            'Accept': 'application/json', // response json
            'Accept-Language': i18n.language,
          },
          body: JSON.stringify(formData),
        });
        const resBody = await res.json();
        if (res.ok) {
          setshowimage(`${storageURL}${resBody.data?.[0].qr_path}`)
          setFormData({
            first_name: '',
            last_name: '',
            work_address: "",
            academic_level: '',
            specialization: '',
            country: "",
            city: "",
            landline_phone: "",
            email: "",
            phone: "",
            interests: [],
            interest_details: "",
            heard_about_us: "",
            other_heard_about_us: '',
            events: [],
          });
          setOpenSnackbar(true);
          setMessage(resBody?.message);
        }
        else {
          if(res.status === 422) {
            setOpenSnackbar(true);
            setMessage(resBody?.message);
          }
          else {
            setOpenSnackbar(true);
            setMessage(resBody?.message);
          }
        };
      } catch (error) {
        setOpenSnackbar(true);
        setMessage("Proplem in the server or check your internet")
      } finally {
        setLoading(false);
      }
    }
  };

  
  return (
    <div dir={i18n.language === "en" ? "ltr": "rtl"} className="max-w-7xl mx-auto px-4 py-4">
      {!showimage
        ?
        (
          <div>
            <div className='flex text-center justify-center mb-5'>
              <h1 className='conferenceName text-[#0077B6] text-[30px] font-bold'>
                {t("adentalis")}
              </h1>
            </div>
            <div className='flex text-center justify-center'>
              <h1 className='w-fit text-[#0077B6] font-bold mb-5 px-3 py-2
              border-4 border-solid border-[#0077B6] rounded-lg'
              >
                {t("registration_form")}
              </h1>
            </div>
            {loading && (
              <div className="mb-4">
                <LinearProgress />
                <p className="text-center text-sm text-gray-600 mt-1">{t("submitting")}...</p>
              </div>
            )}
            <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
          >
            {/* visitor-information */}
            <div className='visitor-information'>
              <h4 className='text-[#575555a8] font-bold mb-5'>{t("visitor_information")} :</h4>
              <div className="flex flex-wrap gap-4">
                <div className="flex w-full gap-4 max-md:flex-col">
                  <TextField
                    required
                    label={t("first_name")}
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    error={errorsData.first_name}
                    helperText={errorsData.first_name ? t("first_name_is_required") : ""}
                    className="flex-1"
                  />
                  <TextField
                    required
                    label={t("last_name")}
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    error={errorsData.last_name}
                    helperText={errorsData.last_name ? t("last_name_is_required") : ""}
                    className="flex-1"
                  />
                  <TextField
                    required
                    label={t("work_address")}
                    name="work_address"
                    value={formData.work_address}
                    onChange={handleChange}
                    error={errorsData.work_address}
                    helperText={errorsData.work_address ? t("work_address_is_required") : ""}
                    className="flex-1"
                  />
                </div>
                <div className="flex w-full gap-4 max-md:flex-col">
                <AcademicLevel formData={formData} handleChange={handleChange} errorsData={errorsData}/>
                <TextField
                    label={t("specialization")}
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleChange}
                    // error={errorsData.specialization}
                    // helperText={errorsData.specialization ? t("specialization_is_required") : ""}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>

            {/* contact-information */}
            <div className='contact-information mt-10'>
              <h4 className='text-[#575555a8] font-bold mb-5'>{t("contact_information")} :</h4>
              <div className="flex flex-wrap gap-4">
                <div className="flex w-full gap-4 max-md:flex-col">
                  <Autocomplete
                    name="country"
                    value={
                      allCountries.find(
                        (country) => country.name_en === formData.country
                      ) || null
                    }
                    onChange={(event, element) => {
                      console.log(element)
                      setFormData(prev => ({
                        ...prev,
                        country: element ? element.name_en : ""
                      }));
                      setErrorsdata(prev => ({ ...prev, country: false }));
                    }}
                    options={allCountries}
                    getOptionLabel={
                      i18n.language === "ar"
                        ? (option) => option?.name_ar || ""
                        : (option) => option?.name_en || ""
                    }
                    className="flex-1"
                    renderInput={(params) => 
                    <TextField 
                      {...params} 
                      label={t("country")}
                      error={errorsData.country}
                      helperText={errorsData.country ? t("country_is_required") : ""}
                    />}
                  />
                  <TextField
                    required
                    label={t("city")}
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    error={errorsData.city}
                    helperText={errorsData.city ? t("city_is_required") : ""}
                    className="flex-1"
                  />
                  <TextField
                    // required
                    type='number'
                    label={t("landline_phone")}
                    name="landline_phone"
                    value={formData.landline_phone}
                    onChange={handleChange}
                    // error={errorsData.landline_phone}
                    // helperText={errorsData.landline_phone ? t("landline_phone_is_required") : ""}
                    className="flex-1"
                  />
                </div>
                <div className="flex w-full gap-4 max-md:flex-col">
                  <TextField
                    required
                    label={t("mail")}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    error={errorsData.email}
                    helperText={errorsData.email ? t("please_enter_a_valid_mail") : ""}
                    className="flex-1"
                    placeholder='example@domain.com'
                  />
                  <div className='w-[50%] max-md:w-full'>
                    <PhoneInput
                      country={"sy"}
                      enableSearch={true}
                      value={formData.phone}
                      onChange={(value) => {
                        setFormData(prev => ({ ...prev, phone: value }));
                        setErrorsdata(prev => ({ ...prev, phone: false }));
                      }}
                      inputStyle={{
                        borderRadius: "4px",
                        border: errorsData.phone ? "1px solid red" : "1px solid #c4c4c4",
                        width:"100%",
                        height: "56px"
                      }}
                      // arrow
                      buttonStyle={{
                        marginRight: "8px",
                        direction: "ltr",
                      }}
                      // flag
                      containerStyle={{
                        display: "flex",
                        flexDirection: i18n.language === "ar" ? "row-reverse": "",
                      }}
                    />
                    {errorsData.phone && (
                      <p className="text-red-500 text-sm mt-1">{t("phone_number_is_required")}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Selected and others */}
            <div className='mt-10'>
              <div className="flex flex-wrap gap-4">
                <div className="flex w-full gap-4 max-md:flex-col">
                  <div className="flex-1">
                      <h4 className='text-[#575555a8] font-bold mb-5'>{t("fields_of_medical_interest")} :</h4>
                      <MedicalInterests formData={formData} handleChange={handleChange} errorsData={errorsData}/>
                  </div>
                  <div className="flex-1">
                    <h4 className='text-[#575555a8] font-bold mb-5'>{t("other_interest")} :</h4>
                    <div className="flex flex-wrap gap-4">
                      <div className="flex w-full gap-4 max-md:flex-col">
                        <TextField
                            label={t("other_interest")}
                            name="interest_details"
                            value={formData.interest_details}
                            onChange={handleChange}
                            className="flex-1"
                          />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='mt-10 w-full'>
                  <div className="flex flex-wrap gap-4">
                    <div className="flex w-full gap-4 max-md:flex-col">
                      <div className="flex-1">
                          <h4 className='text-[#575555a8] font-bold mb-5'>{t("events")} :</h4>
                          <Events formData={formData} handleChange={handleChange} errorsData={errorsData}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-full gap-4 max-md:flex-col">
                  <div className="flex-1">
                      <h4 className='text-[#575555a8] font-bold mb-5'>{t("how_did_you_hear_about_us")} :</h4>
                      <HearAboutUs formData={formData} handleChange={handleChange} errorsData={errorsData}/>
                  </div>
                {formData.heard_about_us === "other"
                ?(
                  <div className="flex-1">
                    <h4 className='text-[#575555a8] font-bold mb-5'>{t("other_hear_about_us")} :</h4>
                    <div className="flex flex-wrap gap-4">
                      <div className="flex w-full gap-4 max-md:flex-col">
                        <TextField
                          required
                          label={t("other_hear_about_us")}
                          name="other_heard_about_us"
                          value={formData.other_heard_about_us}
                          onChange={handleChange}
                          error={errorsData.other_heard_about_us}
                          helperText={errorsData.other_heard_about_us ? t("other_heard_about_us_is_required") : ""}
                          className="flex-1"
                        />
                      </div>
                    </div>
                  </div>
                )
                :(
                  <></>
                )}
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="mt-10 flex justify-center">
              <Button
                type="submit"
                variant="contained"
                className='!bg-[#00B8A9] w-[40%] p-2'
                style={{ borderRadius: "6px", fontSize: "15px", fontWeight: "bold" }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : t("submit")}
              </Button>
            </div>
            </Box>
          </div>
        )
        :
        (
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center">
            <div className="order-1 md:order-2">
              <div className='flex justify-evenly items-center'>
                <Button
                  variant="contained"
                  className='!bg-[#00529C] mt-[-50px]'
                  style={{ borderRadius: "6px", fontSize: "15px", fontWeight: "bold" }}
                  onClick={() => {
                    fetch(showimage)
                      .then(response => response.blob())
                      .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'registration_qr.png'; // custom filename
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                      })
                      .catch(console.error);
                  }}
                >
                  <DownloadIcon/>
                </Button>
                <Button
                  variant="contained"
                  className='!bg-[#25D366] px-6 py-2 text-white ml-5'
                  style={{ borderRadius: "6px", fontSize: "15px", fontWeight: "bold" }}
                  onClick={() => {
                    const encodedText = encodeURIComponent(`Here is your registration QR code: ${showimage}`);
                    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedText}`;
                    window.open(whatsappUrl, '_blank');
                  }}
                >
                  <WhatsAppIcon/>
                </Button>
                <Button
                  variant="contained"
                  className='!bg-[#6E6E6E] px-6 py-2 text-white ml-5'
                  style={{ borderRadius: "6px", fontSize: "15px", fontWeight: "bold" }}
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: 'Your Registration QR Code',
                        text: 'Here is your registration QR code for the event:',
                        url: showimage,
                      })
                      .catch((error) => console.error('Error sharing', error));
                    } else {
                      alert('Sharing is not supported on this device/browser.');
                    }
                  }}
                >
                  <ShareIcon/>
                </Button>
              </div>
              <p className="text-xl mt-5 md:text-2xl font-semibold text-gray-800 max-w-md">
                {t("please_check_your_email")}
              </p>
            </div>
            <img
              src={showimage}
              alt="Registration Successful"
              className="order-2 md:order-1 max-h-[69vh] object-contain"
            />
          </div>
        )
      }
      {/* Notification */}
      <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} variant="filled" 
        severity={message === "تم تسجيل الحساب بنجاح" || message === "Visitor registered successfully" ?"success" : "error"} sx={{ width: '100%', fontWeight:"bold"}}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
    );
};

export default SignUp;




